module.exports = __webpack_public_path__ + "img/mailLight.png?4c47ee3779632ac12a4d75b0a91dae43";